import React from 'react';
import classes from './HeaderItem.css';
import { NavLink } from 'react-router-dom';

const headerItem = (props) => {

    const delimiter = props.first?"":<label>|</label>;

    return (
        props.display ?
        <li className={classes.NavigationItem}>
            {delimiter}
            <NavLink
                id={props.id}
                to={props.link}
                activeClassName={classes.active}
                onClick={props.clicked}
                exact={props.exact} >
                {props.children}
            </NavLink>
        </li> : ''
    );
}

export default headerItem;